import { render } from "./AlertsSettings.vue?vue&type=template&id=5e367b0c"
import script from "./AlertsSettings.vue?vue&type=script&lang=js"
export * from "./AlertsSettings.vue?vue&type=script&lang=js"

import "./AlertsSettings.vue?vue&type=style&index=0&id=5e367b0c&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/demo-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__